import React from 'react';
import IcCheck from 'assets/images/backoffice/capital/ic-approve.svg';
import styles from './ListItem.css';

function Icon(props) {
  const { number, color } = props;
  if (number)
    return <div className={`${styles.number} ${styles[color]}`}>{number}</div>;
  return <img src={IcCheck} className={styles['list-item-icon']} />;
}

function ListItem(props) {
  const { children, number, last, color } = props;

  return (
    <div className={styles.wrapper}>
      {number && !last && <div className={styles['line-step']} />}
      <Icon number={number} color={color} />
      <p className={styles['list-item']}>{children}</p>
    </div>
  );
}

export default ListItem;
